export default "__VITE_ASSET__dc470864__"